import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { inferElectricityProviderClass } from './equityElectricityPriceRule';
import { buildElectricityPricesNarrativeTokens } from './electricityPricesNarrativeTokens';
import type { ElectricityPricesByGeographyResult } from '../../services/electricityPricesByGeographyService';

const CHART_ID = 'electricity_prices';
const VIEW_ID = 'default';

export interface ElectricityPricesNarrativeInput {
  locationName: string;
  customerClassLabel: string;
  latestYear: number;
  avgRevenuePerKwh: number;
  baselineYear: number;
  percentChange: number | null;
  comparisonSentence: string;
}

export function buildElectricityPricesAuthoredBundle(
  input: ElectricityPricesNarrativeInput,
  priceContext?: Pick<
    ElectricityPricesByGeographyResult,
    'utilityName' | 'eia861Cca' | 'eia861Iou'
  > | null
) {
  const tokens = buildElectricityPricesNarrativeTokens(input);
  return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, tokens, undefined, {
    electricityPriceSector: input.customerClassLabel,
    electricityProviderClass: inferElectricityProviderClass({
      utilityName: priceContext?.utilityName ?? null,
      eia861Cca: priceContext?.eia861Cca ?? null,
      eia861Iou: priceContext?.eia861Iou ?? null,
    }),
  });
}

export function buildElectricityPricesKeyInsights(input: ElectricityPricesNarrativeInput): string {
  return buildElectricityPricesAuthoredBundle(input).keyInsights || '';
}

export function electricityPricesOverviewDescription(fallback: string): string {
  return getAuthoredOverview(CHART_ID, VIEW_ID, fallback);
}
